import React from 'react';
import { TranslationProvider } from './hooks/useTranslations';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { LogoSlider } from './components/LogoSlider';
import { HowItWorks } from './components/HowItWorks';
import { PricingSection } from './components/PricingSection';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <TranslationProvider data-id="element-0">
      <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-purple-500 selection:text-white" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <LogoSlider data-id="element-5" />
          <HowItWorks data-id="element-6" />
          <PricingSection data-id="element-7" />
          <Contact data-id="element-8" />
        </main>
        <Footer data-id="element-9" />
      </div>
    </TranslationProvider>;
}